"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorGaugeWrapper = void 0;
const solana_contrib_1 = require("@saberhq/solana-contrib");
const web3_js_1 = require("@solana/web3.js");
const gauges_1 = require("../gauges");
class ValidatorGaugeWrapper {
    constructor(sdk) {
        this.sdk = sdk;
    }
    get provider() {
        return this.sdk.provider;
    }
    get program() {
        return this.sdk.program;
    }
    static async create({ validatorGauge, validatorAccount, validatorIndex, validatorList, }) {
        if (validatorList) {
            validatorGauge.sdk.restoreValidatorList(validatorList);
        }
        else {
            validatorList = await validatorGauge.sdk.fetchValidatorList();
        }
        let validator;
        let index;
        if (validatorAccount) {
            validator = validatorAccount;
            index = validatorList.items.findIndex(v => v.equals(validatorAccount));
        }
        else if (validatorIndex !== undefined) {
            validator = validatorList.items[validatorIndex];
            index = validatorIndex;
        }
        else {
            throw Error('At least one of validator account or index is required.');
        }
        const gaugemeisterWrapper = new gauges_1.GaugemeisterWrapper(validatorGauge.sdk.escrowRelocker, validatorGauge.sdk.gaugemeisterAddress);
        const gaugeAddress = await gauges_1.GaugeWrapper.address(gaugemeisterWrapper, validator.toBuffer());
        const wrapper = new gauges_1.GaugeWrapper(gaugemeisterWrapper.sdk, gaugeAddress);
        const tx = new solana_contrib_1.TransactionEnvelope(validatorGauge.provider, [
            await validatorGauge.program.methods
                .createValidatorGauge({
                validatorAccount: validator,
                validatorIndex: index,
            })
                .accounts({
                payer: validatorGauge.provider.wallet.publicKey,
                marinadeState: validatorGauge.sdk.marinadeStateAddress,
                validatorList: validatorList.address,
                gauge: gaugeAddress,
                gaugemeister: gaugemeisterWrapper.address,
                foreman: await validatorGauge.sdk.foreman(),
                escrowRelockerProgram: wrapper.program.programId,
                systemProgram: web3_js_1.SystemProgram.programId,
            })
                .instruction(),
        ]);
        return {
            tx,
            wrapper,
        };
    }
    static async close({ validatorGauge, validatorAccount, admin, rentCollector, }) {
        const gaugemeisterWrapper = new gauges_1.GaugemeisterWrapper(validatorGauge.sdk.escrowRelocker, validatorGauge.sdk.gaugemeisterAddress);
        const gaugeAddress = await gauges_1.GaugeWrapper.address(gaugemeisterWrapper, validatorAccount.toBuffer());
        const realmWrapper = await gaugemeisterWrapper.realm();
        const signers = [];
        let adminAuthority = validatorGauge.provider.walletKey;
        if (admin) {
            if (admin instanceof web3_js_1.PublicKey) {
                adminAuthority = admin;
            }
            else {
                adminAuthority = admin.publicKey;
                signers.push(admin);
            }
        }
        return new solana_contrib_1.TransactionEnvelope(validatorGauge.provider, [
            await validatorGauge.program.methods
                .closeValidatorGauge()
                .accounts({
                admin: adminAuthority,
                realm: realmWrapper.address,
                rentCollector: rentCollector || validatorGauge.provider.wallet.publicKey,
                marinadeState: validatorGauge.sdk.marinadeStateAddress,
                gauge: gaugeAddress,
                gaugemeister: gaugemeisterWrapper.address,
                foreman: await validatorGauge.sdk.foreman(),
                escrowRelockerProgram: gaugemeisterWrapper.program.programId,
            })
                .instruction(),
        ], signers);
    }
}
exports.ValidatorGaugeWrapper = ValidatorGaugeWrapper;
//# sourceMappingURL=ValidatorGauge.js.map